<template>
    <div class="btn-panel-right">
        <div
            v-if="tooltip"
            class="content-btn"
        >
            <v-tooltip 
                content-class="left"
                left
                v-model="showTooltip['enableScroll']"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        fab
                        class="view-scroll-btn"
                        :class="{
                            'active': !enableScroll,
                            'flash-btn': isMouseWheel && !enableScroll
                        }"
                        @click="toggleLockMouseWheel();"
                    >
                        <v-icon class="icon">
                            icon-mouse
                        </v-icon>
                    </v-btn>
                </template>
                <span>
                    {{ enableScroll ? tooltip['unlockMouseWheel'] : tooltip['lockMouseWheel'] }}
                </span>
            </v-tooltip>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    export default {
        name: 'ScrollButton',
        props: [
            'options',
            'toggleModeWheel'
        ],
        data() {
            return {
                enableScroll: false,
                isMouseWheel: false,
                flashTimeout: null,
                flashDuration: 3000,
                widget: null,
                tooltip: null,
                showTooltip: {
                    'enableScroll': false
                },
                tooltipDuration: 3000,
                tooltipTimeout: null,
            };
        },
        mounted() {
            const el = document.querySelector('.all-widgets');
            el.onwheel = this.isScrolling;
            EventBus.$on('widgetReady', widget => {
                this.widget = widget;
                if (this.widget)
                    this.widget.lockMouseWheel();
            });
        },
        methods: {
            isScrolling() {
                this.isMouseWheel = true;
            },
            toggleLockMouseWheel() {
                if (!this.widget)
                    return;
                this.enableScroll = !this.enableScroll;
                if (this.enableScroll)
                    this.widget.unlockMouseWheel();
                else
                    this.widget.lockMouseWheel();
            },
            hideTooltips() {
                let tooltipKeys = [];
                for (const [key, value] of Object.entries(this.showTooltip))
                    if (value == true)
                        tooltipKeys.push(key);

                tooltipKeys.forEach(key => {
                    this.showTooltip[key] = false;
                });
            }
        },
        watch:{
            toggleModeWheel() {
                if (!this.enableScroll)
                    this.toggleLockMouseWheel();
            },
            'options.gui'() {
                this.tooltip = {};
                this.tooltip['lockMouseWheel'] = this.options.gui && this.options.gui.lockMouseWheel ? this.options.gui.lockMouseWheel.text : null;
                this.tooltip['unlockMouseWheel']  = this.options.gui && this.options.gui.unlockMouseWheel ? this.options.gui.unlockMouseWheel.text : null;
            },
            showTooltip: {
                handler() {
                    if (this.tooltipTimeout)
                        window.clearTimeout(this.tooltipTimeout);

                    this.tooltipTimeout = window.setTimeout(() => {
                        this.hideTooltips();
                    }, this.tooltipDuration);
                },
                deep: true
            },
            isMouseWheel() {
                if (this.flashTimeout)
                    window.clearTimeout(this.flashTimeout);

                this.flashTimeout = window.setTimeout(() => {
                    this.isMouseWheel = false;
                }, this.flashDuration);
            }
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/_common.scss";
    @import "@/assets/scss/components/_btn-scroll.scss";
</style>


// WEBPACK FOOTER //
// src/components/ScrollButton.vue